import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="timer"
export default class extends Controller {
  static targets = ["display"]
  static values = {
    started: String
  }

  connect() {
    this.startedAt = new Date(this.startedValue)
    this.updateTimer()
    this.interval = setInterval(() => this.updateTimer(), 1000)
  }

  disconnect() {
    if (this.interval) {
      clearInterval(this.interval)
    }
  }

  updateTimer() {
    const now = new Date()
    const elapsed = Math.floor((now - this.startedAt) / 1000) // seconds

    const hours = Math.floor(elapsed / 3600)
    const minutes = Math.floor((elapsed % 3600) / 60)
    const seconds = elapsed % 60

    let display
    if (hours > 0) {
      display = `${hours}:${this.pad(minutes)}:${this.pad(seconds)}`
    } else {
      display = `${minutes}:${this.pad(seconds)}`
    }

    this.displayTarget.textContent = display
  }

  pad(num) {
    return num.toString().padStart(2, '0')
  }
}
